import styled from '@emotion/styled';
import { COLORS, SPACING } from '@zola/zola-ui/src/styles/emotion';

export const AddedToBookedVendorContainer = styled.div`
  background: ${COLORS.GEYSER};
  width: fit-content;
  border-radius: ${SPACING.XXS};
  margin-top: ${SPACING.XXS};
  padding: ${SPACING.XXS} ${SPACING.XS};
`;
